module.exports = __webpack_public_path__ + "assets/img/sea3.9faa5cab.png";